<template>
  <b-modal v-model="modalShow" centered hide-header scrollable>
    <recommends :recommends="recommends" :order="hideModalAndGoOrder" />
    <template v-slot:modal-footer>
      <div class="text-align-center">
        <so-close-button @click="handleClose">{{ $t('common.close') }}</so-close-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import Recommends from '@/components/recommends/Recommends'
import SoCloseButton from '@/components/common/SoCloseButton'

export default {
  components: {
    Recommends,
    SoCloseButton,
  },
  data() {
    return {
      recommendIntervalHandle: null,
      recommends: [],
      swiperOption: {
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.isShowingScheduledRecommendModal
      },
      set() {
        this.$store.dispatch('modal/setShowingScheduledRecommendModal', false)
      },
    },
    ...mapGetters({
      isAuthQuitted: 'auth/getIsAuthQuitted',
      hasMenu: 'menu/getHasMenu',
      shopId: 'seat/getShopId',
      seatStatus: 'seat/getSeatStatus',
      isShowingModal: 'modal/isShowingModal',
      isShowingScheduledRecommendModal: 'modal/isShowingScheduledRecommendModal',
      preparedRecommends: 'scheduledRecommend/getPreparedRecommends',
      scheduledRecommends: 'scheduledRecommend/getRecommends',
      firstOrderTime: 'scheduledRecommend/getFirstOrderTime',
      lastOrderTime: 'scheduledRecommend/getLastOrderTime',
      language: 'setting/getLanguage',
    }),
    isNormalStatus() {
      return this.seatStatus === 0
    },
    isMenuPage() {
      return this.$route.name === 'shopMenu'
    },
    isStandby() {
      return !this.isShowingModal && this.isNormalStatus && this.isMenuPage
    },
  },
  watch: {
    lastOrderTime(date) {
      if (!this.firstOrderTime) {
        this.$store.dispatch('scheduledRecommend/setFirstOrderTime', date)
      }
    },
    hasMenu(hasMenu) {
      if (hasMenu) this.fetchRecommend(this.shopId)
    },
    scheduledRecommends() {
      this.show()
      this.setRecommendInterval()
    },
    isAuthQuitted(next) {
      if (next) clearInterval(this.recommendIntervalHandle)
    },
  },
  methods: {
    ...mapActions({
      fetchRecommend: 'scheduledRecommend/fetchRecommend',
    }),
    setRecommendInterval() {
      this.recommendIntervalHandle = setInterval(() => {
        this.show()
      }, 1000 * 60)
    },
    handleClose() {
      this.$store.dispatch('modal/setShowingScheduledRecommendModal', false)
    },
    show() {
      if (!this.isStandby) return
      this.recommends = this.preparedRecommends()
      if (!this.recommends.length) return
      this.recommends.forEach((recommend) => {
        this.$store.dispatch('scheduledRecommend/setRecommendDone', recommend.id)
      })
      this.$store.dispatch('modal/setShowingScheduledRecommendModal', true)
    },
    hideModalAndGoOrder(recommend) {
      this.$store.dispatch('modal/setShowingScheduledRecommendModal', false)
      const { id, itemList } = recommend
      if (itemList.length === 1) {
        this.$router.push(`/ad/${id}/order/${itemList[0].itemCode}`)
      } else if (itemList.length > 1) {
        this.$router.push({ name: 'ad', params: { adId: id } })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .modal-dialog {
    @media (max-width: 575px) {
      margin-left: 24px !important;
      margin-right: 24px !important;
    }
  }
  .modal-body {
    width: 100%;
    padding-bottom: 0;
    overflow: visible;
    overflow-y: visible !important;
    padding-left: 24px !important;
    padding-right: 24px !important;
  }
  .modal-content {
    overflow: visible !important;
  }
  .modal-footer {
    display: flex;
    justify-content: center;
    padding: 10px;
    border-top: none;
  }
}
</style>
